import React, { useState, useEffect } from 'react';
import './utiles.css';

const contactUsRedirection = () => {
    window.open("https://kokos.ai/contact-us.html");
}

const downlaodfile = () =>{
    window.location.replace("https://umt-dev-stageing1.s3.ap-south-1.amazonaws.com/utilities.zip");
}

function Utilites() {
    return (
        <div className="utilesMain">
            <div>
                <div className="utiles-downlaod-heading">Download sample csv file</div>
                <div className="utiles-downlaod-btn" onClick={()=>downlaodfile()}>Download</div>
            </div>
            <div>
                <div className="utiles-contactus-heading">For further details please contact us</div>
                <div className="utiles-contactus-btn" onClick={() => contactUsRedirection()}>Contact Us</div>
            </div>
        </div>
    );
}

export default Utilites;